import Component from '@glimmer/component';
import { service } from '@ember/service';

export default class ProductItemComponent extends Component {
  @service session;
}
